/**
 * 🔒 How many of a toolbar's groups fold into its overflow menu (decision 1537):
 * the groups stand in one row, and where the row is narrower than they are, the
 * groups from the right go behind one More control, never onto a second row.
 * The widths are each group's as last drawn in the row, in order; `gap` is the
 * space between two neighbours and `more` the More control's own width.
 *
 * 💰 A pure count rather than a measurement, so the rule is proved without a
 * browser: the editor measures and this decides.
 */
export function foldedGroups(widths: readonly number[], available: number, more: number, gap: number): number {
  const count = widths.length;
  const span = (kept: number): number => widths.slice(0, kept).reduce((sum, width) => sum + width, 0) + gap * Math.max(0, kept - 1);
  if (count === 0 || span(count) <= available) return 0;
  for (let kept = count - 1; kept > 0; kept -= 1) {
    if (span(kept) + gap + more <= available) return count - kept;
  }
  return count;
}
